import { render, staticRenderFns } from "./ITList.vue?vue&type=template&id=004a3fe6&"
import script from "./ITList.vue?vue&type=script&lang=js&"
export * from "./ITList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports